import {
  MDBAlert,
  MDBBreadcrumb,
  MDBBreadcrumbItem,
  MDBBtn,
  MDBChipsInput,
  MDBCol,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalFooter,
  MDBModalHeader,
  MDBModalTitle,
  MDBRow,
  MDBScrollspy,
  MDBScrollspyLink,
  MDBSpinner,
  MDBTabs,
  MDBTabsContent,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsPane
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { FormProvider, useFieldArray, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import { getSpecificAAGroup, updateAAGroup } from "../apiclients/streamsapi_bridge";
import Body from "../components/body/BodyPage";
import AADiaLByName from "../components/editviews/aagroup/AADialByName";
import AADialByNameEdit from "../components/editviews/aagroup/AADialByNameEdit";
import AAGeneralSettings from "../components/editviews/aagroup/AAGeneralSettings";
import AARouting from "../components/editviews/aagroup/AARouting";
import MainLinks from "../components/navlinks/MainLinks";
import SaveChanges from "../components/topviews/saveCancel";
import { useAdminContext } from "../components/adminstore/Admin-Context";
import EditWarning from "../components/header/EditWarning";
import ImportProgressWarning from "../apiclients/ImportProgressWarning";
import { getImpExpStatusNew } from "../apiclients/CommonUtils";
import ImpExpRedirectPopup from "../apiclients/ImpExpRedirectPopup";
import ImportUser from "../components/editviews/user/ImportUser";
import AAVoicemails from "../components/editviews/aagroup/AAVoicemails";

function AccInfo(props) {
  const [basicActive, setBasicActive] = useState("tab1");
  const location = useLocation();
  const navigate = useNavigate();
  const [settingInfoFlag, setsettingInfoFlag] = useState(true);
  const { isEdited, setEdited } = useAdminContext();
  const [targetView, setTargetView] = useState("");
  const [showWarning, setShowWarning] = useState(false);
  const warningToggle = () => setShowWarning(!showWarning);
  const [operatorValue, setoperatorValue] = useState({});
  const [showExportWarning, setShowExportWarning] = useState(false);
  const exportwarningToggle = () => setShowExportWarning(!showExportWarning);
  const [warningMessage, setWarningMessage] = useState("");
  const [showImpExpRedirect, setShowImpExpRedirect] = useState(false);
  const [importUser, setimportUser] = useState(false);
  const importuserToggle = () => setimportUser(!importUser);
  const [firstRequest, setfirstRequest] = useState(false);
  const handleBasicClick = (value) => {
    if (value === basicActive) {
      return;
    } else if (isEdited) {
      setTargetView(value);
      setShowWarning(true);
      return;
    }
    setBasicActive(value);
    setDailNameEditFlag(false);
    if (value === 'tab1') {
      setsettingInfoFlag(true);
    } else {
      setsettingInfoFlag(false);
    }
  };

  const handleOk = () => {
    setEdited(false);
    reset();
    if (targetView.indexOf("/") !== -1) {
      navigate(targetView);
    } else {
      setBasicActive(targetView);
    }
    setShowWarning(false);
  };

  const basicData1 = {
    columns: ["Name", "Remove"],
    rows: [
      ["Poly VVX 601", "X"],
      ["Poly VVX 601", "X"],
    ],
  };


  const [selectedRegion, setSelectedRegion] = useState("IN");
  const { t, i18n } = useTranslation();

  const [AddNumbers, setAddNumbers] = useState(false);
  const toggleShow12 = () => setAddNumbers(!AddNumbers);
  const [defaultAAValues, setDefaultAAValues] = useState({});


  const ref = useRef(null);
  const [AAGInfo, setAAGInfo] = useState(
    location.state ? location.state : {}
  );
  const [aagcode, setaagcode] = useState('');
  const [grptitle, setGrpTitle] = useState('');
  const [aaextension, setAAExtension] = useState('');
  const [dids, setDids] = useState([]);
  // const [aabillingGrp, setAABillingGrp] = useState([]);
  const [groupname, setGroupName] = useState("");
  const [dialNameDirectList, setDialNameDirectList] = useState([]);
  const [dialNameEditFlag, setDailNameEditFlag] = useState(false);
  const [dialDirName, setDialDirName] = useState('');
  const [dialDirId, setDialDirId] = useState('');
  const [successMessage, setSuccessMessage] = useState("");
  const [message, setMessage] = useState([]);
  const [rerender, setRerender] = useState(false);
  const [destinationTypes, setDestinationTypes] = useState([]);
  const [serverError, setServerError] = useState([]);
  const [newRouteFlag, setNewRouteFlag] = useState(false);;
  const [greetingsInfo, setGreetingsInfo] = useState({});
  const [isloading, setIsloading] = useState(false);
  const [assocCallFlows, setAssocCallFlows] = useState([]);
  const [reqFromCallFlow, setreqFromCallFlow] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [voicemailEAddress, setvoicemailEAddress] = useState("");
  const COMMANDS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    35,
    42, // 35 = '*', 42 = '#'
  ];
  const defaultKeys = {
    title: "",
    timeout_flag: false,
    timeout: 0,
    destination_type: -1,
    value: "",
    timeout_routing: "",
    timeout_dest_type: -1,
    cid_pass_flag: true,
    cid_pass: "",
    phnumber: "",
  };

  const setdistinationList = (destinations) => {
    const fullList = COMMANDS.map((cmd) => {
      const existing = destinations?.find((item) => item.command === cmd);
      if (existing) {
        const { timeout_routing, ...rest } = existing
        return {
          ...rest,
          operatorValue: { ...rest, destination_type: existing.type, timeout_routing },
          destination_type: -1,
          value: "",
          phnumber: (rest.type && rest.type === "4" && rest?.title) ? rest.title : "",
          cid_pass_flag: existing.cid_pass_flag !== undefined ? existing.cid_pass_flag === 1 ? true : false : true,
          timeout_flag: existing.timeout_flag === 1 ? true : false,
          cid_pass: existing.cid_pass ?? "-1",
          timeout: existing.timeout ?? 0,
        };
      }
      return {
        ...defaultKeys,
        command: cmd,
        operatorValue: { ...defaultKeys, command: cmd },
      };
    });
    return fullList;
  }

  const methods = useForm({
    defaultValues: {
      name: "",
      extension: 0,
      adddids: [],
      removedids: [],
      routing: [],
      billing_grp: 0,
      loc_id: 0,
      enable_moh: true,
      dirsearchtype: 2,
      directorylistid: 0,
      operator: {},
      deleteroutingdstns: [],
      voice_mail: {
        vm_pin: 0,
        play_msg_time_stmp: false,
        email_notify: true,
        email_address: "",
        inc_user_sup: true,
        vm_delete: true,
        email_transcript: true,
        broadcast_vm_to_account: false,
      },
    }
  });

  const {
    formState,
    reset,
    setError,
    handleSubmit,
    watch,
    control,
  } = methods;
  const { isDirty, errors } = formState;

  useEffect(() => {
    if (successMessage) {
      setMessage(true);
      setTimeout(() => {
        setMessage(false);
        setSuccessMessage(""); // Clear the success message in the parent component
      }, 5000);
    }
  }, [successMessage]);

  const { fields, replace } = useFieldArray({
    control,
    name: "routing",
  });


  useEffect(() => {
    async function fetchAAGroupData() {
      setIsloading(true);
      const response = await getSpecificAAGroup(JSON.parse(sessionStorage.getItem("admin_session")).siteid, AAGInfo.code);
      if (!response.json) {
        const message = `An error has occured: ${response.statusText}`;
        return;
      }
      setTimeout(() => {
        setIsloading(false)
      }, 1000);
      const rawData = await response.json();
      console.log("specific AA group response :::::: " + JSON.stringify(rawData));
      if (!rawData) {
        window.alert(`info with id  not found`);
        navigate("/");
      }
      setaagcode(AAGInfo.code);
      setGrpTitle(rawData?.groupName ?? "");
      //alert(rawData.extension);
      setAAExtension(rawData.extension ? rawData.extension : 0);
      setDids(rawData?.dids ? rawData.dids : []);
      // setAABillingGrp(rawData?.billingGroups ? rawData?.billingGroups : []);
      setGroupName(AAGInfo.title);
      //setAAGInfo(rawData);
      setDialNameDirectList(rawData.directoryList);
      const destinationList = await setdistinationList(rawData?.destinations ?? []);
      // console.log("destinationList ::::::::::::::::::::::::::::: " + JSON.stringify(destinationList));
      setDestinationTypes(destinationList);
      setoperatorValue(rawData?.operator ?? {});
      setvoicemailEAddress(rawData?.voice_mail?.email_address
            ? rawData.voice_mail.email_address
            : "");

      reset({
        name: rawData?.groupName ?? "",
        extension: rawData?.extension ? parseInt(rawData.extension) : 0,
        adddids: [],
        removedids: [],
        routing: destinationList,
        billing_grp: rawData.billing_grp[0]?.group_id ? parseInt(rawData.billing_grp[0].group_id) : 0,
        loc_id: rawData?.loc_id[0]?.id ? parseInt(rawData?.loc_id[0]?.id) : 0,
        enable_moh: true,
        dirsearchtype: rawData?.dirsearchtype ? parseInt(rawData?.dirsearchtype) : 2,
        directorylistid: rawData?.directorylistid ? parseInt(rawData?.directorylistid) : 0,
        operator: {},
        deleteroutingdstns: [],
        voice_mail: {
          vm_pin: rawData?.voice_mail?.vm_pin
            ? parseInt(rawData.voice_mail.vm_pin)
            : 0,
          play_msg_time_stmp:
            rawData?.voice_mail?.play_msg_time_stmp != undefined
              ? rawData.voice_mail.play_msg_time_stmp
              : false,
          email_notify:
            rawData?.voice_mail?.email_notify != undefined
              ? rawData?.voice_mail?.email_notify
              : true,
          email_address: rawData?.voice_mail?.email_address
            ? rawData.voice_mail.email_address
            : "",
          inc_user_sup:
            rawData?.voice_mail?.inc_user_sup != undefined
              ? rawData.voice_mail.inc_user_sup
              : true,
          vm_delete:
            rawData?.voice_mail?.vm_delete != undefined
              ? rawData.voice_mail.vm_delete
              : true,
          email_transcript:
            rawData?.voice_mail?.email_transcript != undefined
              ? rawData.voice_mail.email_transcript
              : true,
          broadcast_vm_to_account:
            rawData?.voice_mail?.broadcast_vm_to_account != undefined
              ? rawData.voice_mail.broadcast_vm_to_account
              : false,
        },
      })
      setGreetingsInfo(rawData.greetings);
      setRerender(false);
      setAssocCallFlows(rawData.associated_callflows);
    }

    if ((AAGInfo.code || rerender) && settingInfoFlag) {
      fetchAAGroupData();
    }

  }, [AAGInfo.code, rerender, settingInfoFlag])

  // useEffect(() => {
  //   if (Object.keys(defaultAAValues).length !== 0) reset(defaultAAValues);
  // }, [defaultAAValues]);

  function closeSave(e) {
    setDestinationTypes([]);
    reset();
    setRerender(true);
    // setsettingInfoFlag(true);
  }

  useEffect(() => {
    const aadetails = localStorage.getItem("AAGrpInfo") ? JSON.parse(localStorage.getItem("AAGrpInfo")) : null;

    if (aadetails && Object.keys(aadetails).length > 0) {
      setreqFromCallFlow(true);
      setAAGInfo({ code: parseInt(aadetails.code), title: aadetails.title });
      localStorage.removeItem("AAGrpInfo");
    }
  }, []);



  const [verticalActive, setVerticalActive] = useState('tab1');

  const handleVerticalClick = (value) => {
    if (value === verticalActive) {
      return;
    }

    setVerticalActive(value);
  };

  const isdirtyFields =
    Object.keys(formState.dirtyFields).length === 0 ? false : true;
  //alert(isdirtyFields + " ::: isdirtyFields");

  useEffect(() => {
    setEdited(isdirtyFields)

  }, [isdirtyFields])

  const onSubmit = async (data) => {
    const dirtyFields = formState.dirtyFields;

    let modifiedData = {};

    console.log("dirtyFields ::::::::::::::::" + JSON.stringify(dirtyFields));
    console.log("data ::::::::::::::::" + JSON.stringify(data));
    const { routing: dirtyRouting, ...restDirtyFields } = dirtyFields;
    const { routing: routingData, ...restDataFields } = data;

    const modifiedRouting = getModifiedRouting(dirtyRouting, routingData, data.deleteroutingdstns);

    const updatedFields = extractModifiedFields(restDirtyFields, restDataFields);
    modifiedData = { ...updatedFields };
    if (modifiedRouting && Object.entries(modifiedRouting).length > 0) {
      modifiedData = { ...modifiedData, routing: modifiedRouting };
    }


    console.log("modifiedData ::::::::: " + JSON.stringify(modifiedData));
    // return;

    if (modifiedData) {
      modifiedData.reqid = 25;
      modifiedData.siteid = JSON.parse(
        sessionStorage.getItem("admin_session")
      ).siteid;
      modifiedData.code = parseInt(aagcode);
      console.log(JSON.stringify(modifiedData));
      setIsloading(true);
      let saverep = await updateAAGroup(modifiedData);
      console.log(saverep);
      setTimeout(() => {
        setIsloading(false)
      }, 1000);
      let saverepeMsg = await saverep.json();
      if (saverepeMsg.status && saverepeMsg.status == "success") {
        setNewRouteFlag(true);

        setRerender(true);
        setSuccessMessage(saverepeMsg.message);
        if (reqFromCallFlow) {
          if (window.opener && window.opener?.receiveMessageFromAAChild) {
            window.opener.receiveMessageFromAAChild(1); // Send a message to the parent
          }
          setreqFromCallFlow(false);
          window.close();


        }
      } else {

        if (saverepeMsg.message?.errors) {
          //alert(JSON.stringify(saverepeMsg.message?.errors));
          saverepeMsg.message.errors.forEach((err) => {
            if (err.position !== undefined) {
              const errlist = [...serverError, err];
              setServerError(errlist);
              if (err.param_name?.includes("routing") && err.param_name.split(".").length > 1) {
                const fieldParts = err.param_name.split("."); // ["routing", "timeout_routing"]
                if (fieldParts.length >= 2) {
                  // Construct the proper field path: routing[position].fieldName
                  const fieldName = fieldParts.slice(1).join("."); // handles nested fields like "timeout_routing"
                  const errorFieldPath = `routing[${err.position === 35 ? 10 : err.position === 42 ? 11 : err.position}].${fieldName}`;

                  console.log(`Setting error for field: ${errorFieldPath}`);

                  setError(errorFieldPath, {
                    type: "server",
                    message: err.message,
                  });

                  // Optional: Scroll to the error field
                  setTimeout(() => {
                    const fieldElement = document.querySelector(
                      `[name="${errorFieldPath}"], [name="routing[${err.position}].${fieldName}"]`
                    );
                    if (fieldElement) {
                      fieldElement.focus();
                      fieldElement.scrollIntoView({ behavior: "smooth" });
                    }
                  }, 100);
                }
              }

            } else {
              setError(err.param_name, {
                type: "server",
                message: err.message,
              });
              const fieldElement = document.querySelector(
                `input[name="${err.param_name}"]`
              );
              if (fieldElement) {
                fieldElement.focus();
                fieldElement.scrollIntoView({ behavior: "smooth" });
              }
            }
          });
        }
      }
    }
  };

  const getModifiedRouting = (dirtyRouting, routingData, deletedRouting) => {
    const modifiedRouting = [];

    dirtyRouting?.forEach((dirtyEntry, index) => {
      if (!dirtyEntry || !routingData[index]) return; // skip nulls or invalid data

      const routingEntry = routingData[index];
      if (deletedRouting && deletedRouting.length > 0 && deletedRouting.includes(routingEntry.command)) {
        return;
      }
      const modifiedEntry = { command: routingEntry.command }; // always include command
      const disableTimeout =
        dirtyEntry.hasOwnProperty("timeout_flag") && routingEntry.timeout_flag === false;
      for (const key of Object.keys(dirtyEntry)) {
        if (Object.prototype.hasOwnProperty.call(routingEntry, key)) {
          if (disableTimeout && (key === "timeout" || key === "timeout_routing")) continue;
          if (key === "phnumber") {
            modifiedEntry.value = routingEntry[key];
          } else {
            modifiedEntry[key] = routingEntry[key];
          }
        }
      }

      // Inject destination_type when external-number–specific fields are dirty but the
      // main destination (destination_type) was not changed — mirrors the BusyNoAnswerRoute
      // / HGSettings pattern for busy_or_no_answer.
      if (!("destination_type" in modifiedEntry)) {
        const hasExternalFields = [
          "phnumber",
          // "timeout",
          // "timeout_flag",
          // "timeout_routing",
          // "timeout_dest_type",
          // "cid_pass_flag",
          // "cid_pass",
        ].some((k) => k in dirtyEntry);

        if (hasExternalFields) {
          // routingEntry.type holds the original server type (preserved via ...rest in
          // setdistinationList). For AA external numbers the server uses type "4".
          const origType = parseInt(routingEntry.type ?? routingEntry.destination_type ?? -1);
          if (origType === 4 || (origType === -1 && hasExternalFields)) {
            modifiedEntry.destination_type = 4;
          }
        }
      }

      // Clean up external-only fields when the destination is not an external number,
      // matching the cleanup performed in HGSettings for busy_or_no_answer.
      if (
        "destination_type" in modifiedEntry &&
        modifiedEntry.destination_type !== 4 &&
        modifiedEntry.destination_type !== -1
      ) {
        delete modifiedEntry.timeout_dest_type;
        delete modifiedEntry.timeout_routing;
        delete modifiedEntry.timeout_flag;
        delete modifiedEntry.cid_pass_flag;
        delete modifiedEntry.cid_pass;
      }

      modifiedRouting.push(modifiedEntry);
    });

    return modifiedRouting;
  };

  const extractModifiedFields = (restDirtyFields, restDataFields) => {
    const modifiedData = {};

    for (const field of Object.keys(restDirtyFields)) {
      if (restDirtyFields[field] && restDataFields.hasOwnProperty(field)) {
        const value = restDataFields[field];

        if (
          typeof value === "object" &&
          !Array.isArray(value) &&
          value !== null &&
          field !== "operator"
        ) {
          modifiedData[field] = {};
          for (const subfield of Object.keys(restDirtyFields[field])) {
            if (Object.prototype.hasOwnProperty.call(value, subfield)) {
              modifiedData[field][subfield] = value[subfield];
            }
          }
        } else {
          modifiedData[field] = value;
        }
      }
    }

    return modifiedData;
  };


  const section1 = useRef(null);
  const section2 = useRef(null);
  const section3 = useRef(null);

  const containerRef = useRef(null);


  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const scrollspyLinks = document.querySelectorAll('.nav-link');
      const lastLink = scrollspyLinks[scrollspyLinks.length - 1];
      const stickyParent = lastLink.closest('.sticky-top');
      if (stickyParent && lastLink.classList.contains('active')) {
        lastLink.classList.remove('active');
        for (let i = 0; i < scrollspyLinks.length; i++) {
          const firstLink = scrollspyLinks[i];
          const parent = firstLink.closest('.sticky-top');
          if (parent) {
            firstLink.classList.add('active');
            break;
          }
        }
      }
    }, 100);
    return () => clearTimeout(timeoutId);
  }, []);

  const handleImportAndSubmit = async () => {
    if (formState?.dirtyFields?.extension) {
      const result = await getImpExpStatusNew();
      if (result.status !== 0) {
        if (result.isOwnUser) {
          setShowImpExpRedirect(true);
        } else {
          const { userInfo } = result;
          if (userInfo?.isaccount) {
            setWarningMessage(t("imp_exp_account_progress", { name: userInfo.name ?? "" }));
          } else {
            setWarningMessage(t("imp_exp_other_user_progress", { name: userInfo?.name ?? "" }));
          }
          exportwarningToggle();
        }
        return;
      }
    }
    handleSubmit(onSubmit)();
  };

  return (
    <>
      {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )}
      <MainLinks active={2} />
      <Body tablinks={2}
        sublink={18}
        content={
          <>
            <section className="mb-3">
              <div className="card card-height">
                <div className="card-header py-3 px-0">
                  <h5 className="mb-0">
                    <MDBBreadcrumb>
                      <MDBBreadcrumbItem>
                        <a
                          onClick={(e) => {
                            if (isEdited) {
                              setTargetView("/huntgroup");
                              setShowWarning(true);
                              return;
                            }
                            navigate("/huntgroup");
                          }}
                        >
                          <strong>{t("phoneSystem")}</strong>
                        </a>
                      </MDBBreadcrumbItem>
                      <MDBBreadcrumbItem active>
                        <a
                          onClick={(e) => {
                            if (isEdited) {
                              setTargetView("/autoattendant");
                              setShowWarning(true);
                              return;
                            }
                            navigate("/autoattendant");
                          }}>
                          <strong>{t("AutoAttendants")}</strong>
                        </a>
                      </MDBBreadcrumbItem>
                      <MDBBreadcrumbItem>
                        <a href="">
                          <strong> {grptitle}</strong>
                        </a>
                      </MDBBreadcrumbItem>
                    </MDBBreadcrumb>
                  </h5>
                </div>
                <div className="card-body px-0">
                  <div className="pb-2">
                    <h5 className="mt-2 ">
                      {grptitle}
                    </h5>
                    <p className="mt-2 text-secondary">
                      Extension: {aaextension}
                    </p>
                    {assocCallFlows && assocCallFlows?.length > 0 && (
                      <h6 className="mt-2">
                        <strong className="mt-3 mb-0">Associated Call Flow</strong>
                        <p className="mt-2">
                          {assocCallFlows?.map(obj => (' ' + obj.name + ' : ' + obj.extension + ' ')).toString()}
                        </p>
                      </h6>
                    )}
                  </div>
                  <MDBTabs className="mb-3 ">
                    <MDBTabsItem>
                      <MDBTabsLink
                        onClick={() => handleBasicClick("tab1")}
                        active={basicActive === "tab1"}
                      >
                        {t("settings")}
                      </MDBTabsLink>
                    </MDBTabsItem>
                    {/* <MDBTabsItem>
                      <MDBTabsLink
                        onClick={() => handleBasicClick("tab2")}
                        active={basicActive === "tab2"}
                      >
                        {t("directories")}
                      </MDBTabsLink>
                    </MDBTabsItem> */}
                  </MDBTabs>

                  <MDBTabsContent className="p-0">
                    <MDBTabsPane open={basicActive === "tab1"}>
                      {/* Tab 1 content */}
                      <MDBRow>

                        <MDBCol
                          size="2"
                          md="2"
                          lg="2"
                          sm="12"
                          className="col-sm-100 pr-0 leftTabs"
                        >
                          <MDBScrollspy container={containerRef}>
                            <MDBScrollspyLink targetRef={section1}>
                              {t("general")}
                            </MDBScrollspyLink>
                            <MDBScrollspyLink targetRef={section2}>
                              {t("routing")}
                            </MDBScrollspyLink>
                            <MDBScrollspyLink targetRef={section3}>
                              {t("Voicemail")}
                            </MDBScrollspyLink>
                          </MDBScrollspy>
                        </MDBCol>

                        <MDBCol size="11" md="9" sm-9 className="col-sm-100 leftTabContent">
                          <FormProvider {...methods}>
                            <div className="vtabHeightacd p-0">
                              <div
                                id="element"
                                ref={containerRef}
                                className="scrollspy-example"
                              >
                                <section
                                  ref={section1}
                                  id="section-1"
                                >

                                  <div className="general-settings"
                                    id="general">
                                    <AAGeneralSettings
                                      dids={dids}
                                      aaextension={aaextension}
                                      // aabillingGrp={aabillingGrp}
                                      aagcode={aagcode}
                                      groupname={groupname}
                                      setSuccessMessage={setSuccessMessage}
                                      greetingsInfo={greetingsInfo}
                                      isActive={settingInfoFlag}
                                      operatorValue={operatorValue}
                                      setIsloading={setIsloading}
                                      selectedItem={selectedItem}
                                      setSelectedItem={setSelectedItem}
                                    />

                                  </div>

                                </section>
                                <section
                                  ref={section2}
                                  id="section-2"
                                  style={{ paddingBottom: "5rem" }}
                                >

                                  <div {...(assocCallFlows?.length > 0 ? {
                                    title: "Not allowed to edit as group associated with Call Flows :" + assocCallFlows?.map(ele => ele.name)?.toString(), className: "disabled-form cursor-notAllowed", onClick: (e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                    }
                                  } : {}
                                  )}
                                  >
                                    <AARouting
                                      destinationTypes={destinationTypes}
                                      serverError={serverError}
                                      newRouteFlag={newRouteFlag}
                                      setNewRouteFlag={setNewRouteFlag}
                                      aagcode={aagcode}
                                      settingInfoFlag={settingInfoFlag}
                                      fields={fields}
                                      assocCallFlows={assocCallFlows}
                                      setIsloading={setIsloading}
                                    />
                                  </div>


                                </section>
                                 {/* <div className="routing-border mt-2"></div> */}
                                <section
                                  ref={section3}
                                  id="section-3"
                                >

                                  <div className="general-settings"
                                    id="general">
                                    <AAVoicemails
                                      aagcode={aagcode}
                                      greetingsInfo={greetingsInfo}
                                      voicemailEAddress = {voicemailEAddress}
                                    />

                                  </div>

                                </section>
                              </div>
                            </div>
                            {isdirtyFields && (
                              <SaveChanges
                                onClose={closeSave}
                                isdirtyFields={isdirtyFields}
                                onSave={(e) => {
                                  e.preventDefault();
                                  handleImportAndSubmit();
                                }}
                              />
                            )}
                          </FormProvider>
                        </MDBCol>
                      </MDBRow>
                    </MDBTabsPane>

                    {/* <MDBTabsPane open={basicActive === "tab2"} className="p-1">
                      {!dialNameEditFlag && (
                        <AADiaLByName
                          dialNameDirectList={dialNameDirectList}
                          setDailNameEditFlag={setDailNameEditFlag}
                          setDialDirName={setDialDirName}
                          setDialDirId={setDialDirId}
                          aagcode={aagcode}
                          isActive={basicActive === "tab2"}

                        />
                      )}
                      {dialNameEditFlag && (


                        <AADialByNameEdit
                          dialDirId={dialDirId}
                          dialDirName={dialDirName}
                          aagcode={aagcode}
                        />


                      )}

                    </MDBTabsPane> */}
                  </MDBTabsContent>
                </div>
              </div>
            </section>
          </>
        }
      />



      <MDBModal
        open={AddNumbers}
        setShow={setAddNumbers}
        tabIndex="-1"
      >
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>{t("add_ACDQueue")}</MDBModalTitle>
              <MDBBtn
                className="btn-close"
                color="none"
                onClick={toggleShow12}
              ></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <div>
                <div>
                  <div className="form-group row">
                    <div className="col-12">
                      <div className="form-outlines">
                        <MDBChipsInput
                          label="Example label"
                          editable
                          initialValues={[
                            { tag: "661863 8829" },
                            { tag: "661863 8829" },
                            { tag: "MDBVue" },
                          ]}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <label className="selectall pt-2">
                  {t("selectAll")}
                </label>
                <div>
                  <div className="routing-numbers">
                    <div className="numberadd-green">
                      661863 8829
                    </div>
                    <div className="numberadd-green">
                      661863 8829
                    </div>
                    <div className="numberadd">661863 8829</div>
                    <div className="numberadd">661863 8829</div>
                    <div className="numberadd">661863 8829</div>
                  </div>
                  <div className="routing-numbers">
                    <div className="numberadd">661863 8829</div>
                    <div className="numberadd">661863 8829</div>
                    <div className="numberadd">661863 8829</div>
                    <div className="numberadd">661863 8829</div>
                    <div className="numberadd">661863 8829</div>
                  </div>
                </div>
              </div>
            </MDBModalBody>
            <MDBModalFooter>
              <MDBBtn color="secondary" onClick={toggleShow12}>
                {t("close")}
              </MDBBtn>
              <MDBBtn>{t("add")}</MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
      {successMessage && (
        <MDBAlert
          open
          className="alert-center"
          color="success"
          autohide
          position="bottom-right"
          delay={10000}
        >
          <i className="fas fa-check-circle me-3"></i>
          <span className="alert-msg">{successMessage}</span>
        </MDBAlert>
      )}

      {showExportWarning && (
        <ImportProgressWarning
          warningToggle={exportwarningToggle}
          setShowWarning={setShowExportWarning}
          onOk={exportwarningToggle}
          message={warningMessage}
        />
      )}

      {showImpExpRedirect && (
        <ImpExpRedirectPopup
          onProceed={() => {
            setShowImpExpRedirect(false);
            setfirstRequest(true);
            importuserToggle();
          }}
          onCancel={() => setShowImpExpRedirect(false)}
        />
      )}

      <MDBModal open={importUser} onClose={() => setimportUser(false)} tabIndex='-1'>
        <MDBModalDialog size="fullscreen">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Import User Template</MDBModalTitle>
            </MDBModalHeader>
            <MDBModalBody className="pb-0">
              <ImportUser
                onClose={importuserToggle}
                setIsloading={() => {}}
                onShow={setimportUser}
                show={importUser}
                firstRequest={firstRequest}
                setfirstRequest={setfirstRequest}
              />
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>

      {showWarning && (
        <EditWarning
          warningToggle={warningToggle}
          setShowWarning={setShowWarning}
          onOk={handleOk}
        />
      )}
    </>
  );
}

export default AccInfo;
